import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Lab = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="lab icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M41.5976 20.6684L55.4636 53.8327C55.7996 54.6844 56 55.6247 56 56.6167C55.9976 60.6942 52.772 63.9976 48.8012 63.9976L15.2 64.0001C11.2232 63.9976 8.00002 60.6942 8.00002 56.6167C7.99762 55.6247 8.19802 54.6844 8.54242 53.813L22.4 20.6684V12.8001L25.6 12.8V20.8L16 44.8C16 44.8 16.2308 44.9834 16.7828 45.3884L16.8996 45.4699C17.7144 46.0397 18.1961 46.3765 19.394 46.4C20.5557 46.3715 20.9406 46.0804 21.6438 45.5486C21.6989 45.5069 21.756 45.4638 21.8156 45.4191C22.5716 44.8025 23.798 43.9077 25.6904 43.9385C27.5864 43.9077 28.8116 44.8025 29.5676 45.4191C29.6256 45.4627 29.6813 45.5049 29.7351 45.5457C30.4391 46.0794 30.8243 46.3715 31.9904 46.4C33.1528 46.3715 33.5367 46.0807 34.2385 45.5492C34.2938 45.5074 34.351 45.464 34.4108 45.4191C35.1668 44.8025 36.3932 43.9077 38.2868 43.9385C40.1804 43.9077 41.408 44.8025 42.1652 45.4191C42.2233 45.4629 42.2791 45.5052 42.3329 45.5461C43.0355 46.0796 43.42 46.3715 44.588 46.4C45.7851 46.3766 46.2716 46.0385 47.0865 45.4724L47.2076 45.3884C47.762 44.9834 48 44.8 48 44.8L38.4 20.8L38.4 12.8L41.5976 12.8001V20.6684Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43 3H21L21 10H43V3ZM21 0C19.3431 0 18 1.34315 18 3V10C18 11.6569 19.3431 13 21 13H43C44.6569 13 46 11.6569 46 10V3C46 1.34315 44.6569 0 43 0H21Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M48.1799 60.8H15.8223C13.2708 60.7942 11.2046 58.7159 11.2 56.1466C11.2 55.5287 11.3236 54.9411 11.5443 54.3919L14.238 48.0675C14.9078 48.1887 15.3236 48.4727 15.9243 48.883L16.0268 48.953C16.83 49.5325 18.0353 50.3459 19.8611 50.3261C19.8749 50.3261 19.8895 50.3267 19.9038 50.3273C19.9183 50.3279 19.9327 50.3284 19.9466 50.3284C21.7216 50.3284 22.8749 49.4976 23.5925 48.9239C23.6458 48.8846 23.6972 48.8463 23.7468 48.8094C24.4292 48.302 24.7988 48.0271 25.9244 48C27.0508 48.0271 27.4205 48.3017 28.1034 48.8088C28.1533 48.846 28.205 48.8843 28.2587 48.9239C28.9868 49.5069 30.1678 50.3552 31.9913 50.3261C33.8148 50.3552 34.9958 49.5069 35.7238 48.9239C35.7774 48.8844 35.8288 48.846 35.8786 48.809C36.5595 48.3018 36.9283 48.0271 38.0547 48C39.1795 48.0271 39.5488 48.301 40.2307 48.8068C40.2815 48.8446 40.3341 48.8836 40.3889 48.9239C41.1181 49.5069 42.2968 50.3552 44.1226 50.3261C45.9485 50.3482 47.1572 49.5348 47.9627 48.9553L48.0671 48.8842C48.6702 48.4734 49.0882 48.1886 49.7608 48.0675L52.4625 54.4128C52.6763 54.9411 52.8 55.5287 52.8 56.1466C52.7953 58.7159 50.7291 60.7942 48.1799 60.8Z"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8223 60.8H48.1799C50.7291 60.7942 52.7953 58.7159 52.8 56.1466C52.8 55.5287 52.6763 54.9411 52.4625 54.4128L49.7608 48.0675C49.0882 48.1886 48.6702 48.4734 48.0671 48.8842L47.9627 48.9553C47.1572 49.5348 45.9485 50.3482 44.1226 50.3261C42.2968 50.3552 41.1181 49.5069 40.3889 48.9239C40.3341 48.8836 40.2815 48.8446 40.2307 48.8068C39.5488 48.301 39.1795 48.0271 38.0547 48C36.9283 48.0271 36.5595 48.3018 35.8786 48.809C35.8288 48.846 35.7774 48.8844 35.7238 48.9239C34.9958 49.5069 33.8148 50.3552 31.9913 50.3261C30.1678 50.3552 28.9868 49.5069 28.2587 48.9239C28.205 48.8843 28.1533 48.846 28.1034 48.8088C27.4205 48.3017 27.0508 48.0271 25.9244 48C24.7988 48.0271 24.4292 48.302 23.7468 48.8094C23.6972 48.8463 23.6458 48.8846 23.5925 48.9239C22.8749 49.4976 21.7216 50.3284 19.9466 50.3284C19.9327 50.3284 19.9183 50.3279 19.9038 50.3273C19.8895 50.3267 19.8749 50.3261 19.8611 50.3261C18.0353 50.3459 16.83 49.5325 16.0268 48.953L15.9243 48.883C15.3236 48.4727 14.9078 48.1887 14.238 48.0675L11.5443 54.3919C11.3236 54.9411 11.2 55.5287 11.2 56.1466C11.2046 58.7159 13.2708 60.7942 15.8223 60.8Z"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <rect
      x="30"
      y="23"
      width="7"
      height="3"
      rx="1.5"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <rect
      x="30"
      y="28"
      width="7"
      height="3"
      rx="1.5"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <rect
      x="30"
      y="33"
      width="7"
      height="3"
      rx="1.5"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <rect
      x="30"
      y="38"
      width="7"
      height="3"
      rx="1.5"
      className={`color-iconBrand-default ${pathClass}`}
    />
  </svg>
)
